import Seo from "../Seo";
import PageHeader from "./PageHeader";

export default function PageContainer(props) {
  const { banner, seo_info, title, children } = props;
  const bannerImg = banner?.data?.attributes.formats;

  return (
    <>
      <Seo seo={seo_info} />
      {!!title ? (
        <PageHeader as={"header"} title={title} banner={bannerImg} />
      ) : (
        <PageHeader as={"div"} banner={bannerImg} />
      )}
      {children}
    </>
  );
}
